import Vue from 'vue';
import productGroupTransformer from './../../transformers/productGroup';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(productGroupTransformer.fetch(errors));
};

export default (productId, marketplaceData) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/products/${productId}/marketplace`, marketplaceData)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/marketplaceProduct/update.js